<template>
    <div class="l-ss-c-search-results-wrapper">
        <popup
            :opened="store.state.ui.isFiltersOpened"
            :show-close-icon="false"
            class="l-ss-c-search-popup-filters-popup"
            @close="() => toggleFilters(false)">
            <section-full-filters
                :filters="filterItems"
                :has-results="hasResults"
                :has-selected="hasFilters"
                :total-items-count="totalItemsCount"
                :values="filterValues"
                :all-categories-list="allCategoriesList"
                :all-categories-tree="allCategoriesTree"
                :currency="currencyInOffers"
                :loading-by-filters="loadingByFilters"
                @filters-change="onFilterChange"
                @filter-click="params => $emit('filter-click', params)"
                @click-on-show-offers="$emit('click-on-show-offers', $event)"
                @close="() => toggleFilters(false)"
                @reset="() => $emit('reset-filters')"/>
        </popup>

        <div
            class="l-ss-c-search-popup-content"
            :class="{
                'l-ss-c-filters-left': filterPositionLeft,
                'l-ss-c-search-popup-content-masked': showMask
            }"
            :style="!$configuration.showInput ? 'padding-top: 0' : ''">
            <section-image
                v-if="base64Image && !isShowImageSearchInFilters"
                :key="base64ImageKey"
                :base-image="base64Image"
                :store="store"
                @search="onImageSearch"/>
            <div
                v-if="isShowResultsLoader"
                class="l-ss-c-results-loader">
                <pulse-dots/>
            </div>

            <template v-else>
                <div
                    v-if="isResultsVisible && totalItemsCount"
                    class="l-ss-c-search-popup-content-top">
                    <section-results-info
                        ref="sectionResultsInfo"
                        :search="search"
                        :total-items-count="totalItemsCount"
                        :active-filters="filterValues"
                        @autocomplete-search="onAutocompleteSearch"
                        @params-search="$emit('params-search', $event)"
                        @result-tab-click="$emit('result-tab-click', $event)"
                        @handle-tags-click="onTapAction"/>

                    <section-categories
                        :filters="filterItems"
                        :active-filters="filterValues"
                        @toggle-categories="handleToggleCategories"
                        @toggle-active-category="handleChangeCategory"/>

                    <div class="l-ss-c-section-top-filters">
                        <div
                            v-if="$screen.isMobile"
                            class="l-ss-c-filters-all-filters"
                            :class="{ 'l-ss-c-filters-all-filters-active': !!activeFiltersCount }"
                            @click="toggleFilters(true)">
                            <i v-html="iconFunnel"></i>
                            <span class="l-ss-c-filters-all-filters-label">{{ $t('filters.title') }}</span>
                            <span
                                v-if="!!activeFiltersCount"
                                class="l-ss-c-filters-all-filters-count l-ss-c-count-tag">{{ activeFiltersCount }}</span>
                        </div>
                        <sort
                            v-if="showSort"
                            class="l-ss-c-filters-sort"
                            ref="sortContainer"
                            :sort-by="sortBy"
                            :sort-dest="sortDest"
                            @sort-change="params => $emit('sort-change', params)"
                            @result-sort-click="params => $emit('result-sort-click', params)"/>
                    </div>
                </div>

                <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">
                    <section-filters
                        v-if="showFilters"
                        ref="sectionFilters"
                        :currency="currencyInOffers"
                        :filter-position-left="filterPositionLeft"
                        :filters="filterItems"
                        :has-results="hasResults"
                        :has-selected="hasFilters"
                        :show-sorting="showSorting"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :total-items-count="totalItemsCount"
                        :values="filterValues"
                        :loading-by-filters="loadingByFilters"
                        :all-categories-list="allCategoriesList"
                        :is-show-signature="isShowSignature"
                        :store="store"
                        :base64-image="base64Image"
                        :base64-image-key="base64ImageKey"
                        search-type="search-results"
                        class="l-ss-c-search-popup-content-wrapper-child"
                        @search-image="$emit('search-image', { base64: $event })"
                        @replace-image="toggleImagePicker"
                        @filters-change="onFilterChange"
                        @filter-click="params => $emit('filter-click', params)"
                        @sort-change="params => $emit('sort-change', params)"
                        @result-sort-click="params => $emit('result-sort-click', params)"
                        @reset-filters="$emit('reset-filters', $event)"
                        @close-filters="() => toggleFilters(false)"
                        @open-filters="() => toggleFilters(true)"/>
                    <section-results
                        v-if="isResultsVisible"
                        ref="search-results"
                        :categories="allCategoriesList"
                        :all-categories-tree="allCategoriesTree"
                        :category-id="resultsCategoryId"
                        :store="store"
                        :error-text="requestErrorText"
                        :filter-position-left="filterPositionLeft"
                        :filters="filterItems"
                        :filter-values="filterValues"
                        :group-categories="$configuration.features.shouldGroupCategories"
                        :has-filters="hasFilters"
                        :has-loaded-once="hasLoadedOnce"
                        :has-query="hasQuery"
                        :has-results="hasResults"
                        :is-loading="isLoading"
                        :loading-by-filters="loadingByFilters"
                        :loading-next-page="loadingNextPage"
                        :limit="limit"
                        :currency="currencyInOffers"
                        :search="searchResponse"
                        :search-request-id="searchRequestId"
                        :search-state="searchState"
                        :skip="skip"
                        :templates="offerTemplates"
                        :total-items-count="totalItemsCount"
                        :query="query"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :show-sorting="showSorting"
                        :adult-permission-confirmed="adultPermissionConfirmed"
                        :is-show-signature="isShowSignature"
                        class="l-ss-c-search-popup-content-wrapper-child"
                        @click-adult="toggleAgeCheckPopup"
                        @sort-change="$emit('sort-change', $event)"
                        @filters-change="onFilterChange"
                        @result-sort-click="$emit('result-sort-click', $event)"
                        @autocomplete-search="onAutocompleteSearch"
                        @navigate-category="params => $emit('navigate-category', params)"
                        @navigate-page-next="handleNavigatePageNext"
                        @navigate-page-prev="() => $emit('navigate-page-prev')"
                        @reset-category="onResetCategory"
                        @offer-click="params => $emit('offer-click', params)"
                        @add-to-cart-click="addToCartClickHandler"
                        @remove-from-cart-click="params => $emit('remove-from-cart-click', params)"
                        @add-to-cart="args => $emit('add-to-cart', args)"
                        @add-to-favourites-click="params => $emit('add-to-favourites-click', params)"
                        @remove-from-favourites-click="params => $emit('remove-from-favourites-click', params)"
                        @reset-filters="() => $emit('reset-filters')"
                        @handle-tags-click="(value) => onTapAction(value)"
                        @tags-click="$emit('tags-click', $event)"
                        @result-tab-click="(value) => $emit('result-tab-click', value)"
                        @result-category-click="(value) => $emit('result-category-click', value)"
                        @view-in-category-click="(value) => $emit('view-in-category-click', value)"
                        @page-reload="params => $emit('page-reload', params)"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SectionResults from '@/core/components/section-results/section-results.vue';
    import SectionFilters from '@/core/components/filters/section-filters';
    import SectionImage from '@/core/components/section-image';
    import Popup from '@/core/components/popup';
    import SectionFullFilters from '@/core/components/filters/section-full-filters';
    import ClickOutside from '@/core/directives/clickOutside.js';
    import store from '@/core/store';
    // import AgeCheckPopup from '@/core/components/age-check-popup.vue';
    import PulseDots from '@/core/components/pulse-dots.vue';
    import SectionResultsInfo from '@/core/components/section-results/section-results-info.vue';
    import SectionCategories from '@/core/components/section-results/section-categories/section-categories.vue';
    import Sort from '../../../core/components/sort';

    import iconFunnel from '@/core/assets/images/icons/funnel.svg';

    export default {
        components: {
            SectionResultsInfo,
            PulseDots,
            // AgeCheckPopup,
            SectionFilters,
            SectionResults,
            SectionImage,
            Popup,
            SectionFullFilters,
            SectionCategories,
            Sort,
        },
        directives: {
            'click-outside': ClickOutside,
        },
        inject: ['scrollToTop'],
        props: {
            search: {
                type: Object,
                required: false,
                default: () => null,
            },
            from_completions: {
                type: String,
                default: '',
            },
            filterValues: {
                type: Array,
            },
            currencyInOffers: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            sortBy: {
                type: String,
                default: '',
            },
            isShowSort: {
                type: Boolean,
                default: true,
            },
            filterItems: {
                type: Array,
            },
            offerTemplates: {
                type: Object,
                required: false,
            },
            skip: {
                type: [Number, String],
                default: '',
            },
            searchRequestId: {
                type: String,
                default: '',
            },
            searchResponse: {
                type: Object,
                required: false,
                default: () => null,
            },
            limit: {
                type: Number,
                default: 0,
            },
            isSearchLoading: {
                type: Boolean,
                default: false,
            },
            isCompletionsLoading: {
                type: Boolean,
                default: false,
            },
            loadingByFilters: {
                type: Boolean,
                default: false,
            },
            hasResults: {
                type: Boolean,
                default: false,
            },
            hasQuery: {
                type: Boolean,
                default: false,
            },
            hasLoadedOnce: {
                type: Boolean,
                default: false,
            },
            showResultsMask: {
                type: Boolean,
                default: false,
            },
            hasFilters: {
                type: Boolean,
                default: false,
            },
            errorTextCompletions: {
                type: String,
                default: '',
            },
            errorTextSearch: {
                type: String,
                default: '',
            },
            resultsCategoryId: {
                type: [String, Number, Array],
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
            isFiltersBlockVisible: {
                type: Boolean,
                default: false,
            },
            isResultsVisible: {
                type: Boolean,
                default: false,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
            query: {
                type: String,
                default: '',
            },
            searchState: {
                type: Object,
                default: () => ({
                    public: {},
                    private: {},
                }),
            },
            store: {
                required: true,
                type: Object,
                default: () => store,
            },
            isShowSignature: {
                type: Boolean,
                default: false,
            },
            adultPermissionConfirmed: {
                type: Boolean,
                default: false,
            },
            allCategoriesTree: {
                type: Array,
            },
        },
        data() {
            return {
                base64ImageKey: false,
                prevSearchResponse: [],
                loadingNextPage: false,
            };
        },
        computed: {
            filterPositionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile && this.totalItemsCount >
                    0;
            },
            requestErrorText() {
                return this.errorTextCompletions || this.errorTextSearch || '';
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            categoriesResponse() {
                return this.requestCategories ? this.requestCategories.response : null;
            },
            allCategoriesList() {
                return this.categoriesResponse || [];
            },
            showSorting() {
                return (Boolean(this.hasResults) && this.isShowSort);
            },
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            isShowResultsLoader() {
                if (this.loadingByFilters || this.loadingNextPage || !this.isSearchLoading) {
                    return false;
                }

                return this.isSearchLoading || (!this.isResultsVisible && this.hasResults);
            },
            showMask() {
                return this.showResultsMask || this.store.state.ui.isImageSearchVisible || this.store.state.ui.isVoiceSearchActive;
            },
            base64Image() {
                return this.store.state.base64Image;
            },
            showFilters() {
                return this.isFiltersBlockVisible && this.isResultsVisible && !this.$screen.isMobile;
            },
            iconFunnel( ) {
                return iconFunnel;
            },
            activeFiltersCount() {
                let count = 0;

                this.filterValues.forEach(valueItem => {
                    if (valueItem.options) {
                        count += valueItem.options.length;
                    } else {
                        count += 1;
                    }
                });

                return count;
            },
            showSort() {
                return this.showSorting && this.$configuration.isSortVisible && !this.filterPositionLeft;
            },
            isShowImageSearchInFilters() {
                return this.$configuration.isShowImageSearchInFilters && this.$configuration.layout.filterPosition === 'left';
            },
        },
        watch: {
            'searchState.public': function (state) {
                if (state.query) {
                    this.resetImage();
                }
            },
            base64Image() {
                this.base64ImageKey = !this.base64ImageKey;

                if (this.isShowImageSearchInFilters) {
                    this.onImageSearch(this.base64Image);
                }
            },

            searchResponse(newSearchResponse, prevSearchResponse) {
                this.prevSearchResponse = prevSearchResponse;
            },

            isLoading(value) {
                if (!value) {
                    this.loadingNextPage = false;
                }
            },
        },
        methods: {
            onTapAction(value) {
                this.$emit('search-input-change', { query: value, focus: false });
                this.$emit('handle-search');
            },
            toggleFilters(value) {
                this.$emit('toggle-filters', value);
            },
            resetImage() {
                this.store.commit('base64Image/SET_PROPERTY', null);
            },
            onImageSearch(image) {
                this.$emit('search-image', { base64: image });
            },
            onResetCategory() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });
                this.emitNavigateCategory({ skip: 0, categoryId: '' });
            },
            onAutocompleteSearch(value) {
                this.$emit('autocomplete-search', value);
            },
            handleChangeCategory({ param, categoryName, isActive }) {
                if (!this.$screen.isMobile) {
                    this.$refs.sectionFilters.handleChangeFilter(param);
                } else {
                    this.onFilterChange(param);
                    this.scrollToTop();
                }

                if (isActive) {
                    this.$emit('results-category-click', {
                        categoryName,
                        foundItemsMessage: this.$refs.sectionResultsInfo.foundItemsMessage,
                    });
                }
            },
            handleToggleCategories(toggleName) {
                this.$emit('results-category-click', {
                    categoryName: toggleName,
                    foundItemsMessage: this.$refs.sectionResultsInfo.foundItemsMessage,
                });
            },
            onFilterChange({ field, ...params }) {
                const hasParams = !!Object.keys(params).length;
                const output = this.filterValues
                    .filter(filter => filter.field !== field)
                    .slice(0);

                if (hasParams) {
                    output.push({ field, ...params });
                }

                this.$emit('filters-change', { filters: output, changed: [field] });
            },
            addToCartClickHandler(params) {
                let message = '';

                if (this.$refs.sectionResultsInfo) {
                    message = this.$refs.sectionResultsInfo.foundItemsMessage;
                } else {
                    const searchResultsComponent = this.$refs['search-results'];
                    if (searchResultsComponent.$refs.sectionResultsEmpty) {
                        message = searchResultsComponent.$refs.sectionResultsEmpty.$refs.sectionResultsInfo.message;
                        message = message.replace('<span>', '').replace('</span>', '');
                    } else {
                        message = 'По вашим параметрам ничего не нашлось';
                    }
                }

                params.event.foundItemsMessage = message;

                this.$emit('add-to-cart-click', params);
            },
            handleNavigatePageNext() {
                this.loadingNextPage = true;
                this.$emit('navigate-page-next');
            },
            toggleAgeCheckPopup() {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isShowAgeCheckPopup',
                    value: !this.store.state.ui.isShowAgeCheckPopup,
                });
            },
            toggleImagePicker(event) {
                this.$emit('toggle-image-picker');
                this.$emit('button-image-click', { type: 'buttonImageClick', event });
            },
        },
    };
</script>
